export default __webpack_public_path__ + "static/media/home_tree1.5b4b40fe.png";